import React from 'react'
import {Route, IndexRoute} from 'react-router'
import {requireAuthentication} from './utils/authUtils'
import App from './components/App'
import Layout from './components/layout/Layout'
import LoginPage from './components/login/LoginPage'
import DashboardPage from './components/dashboard/DashboardPage'

export default (
  <Route path='/' component={App}>
    <Route component={requireAuthentication(Layout)}>
      <IndexRoute component={DashboardPage} />
    </Route>
    <Route path='login' component={LoginPage} />
  </Route>
)



/** WEBPACK FOOTER **
 ** ./src/routes.js
 **/